import { watch } from 'vue'
import router from '@/router'
import useCurrentUserProfile from './useCurrentUserProfile'

const useAnonymousRouteGuard = () => {
  const { isAnonymous } = useCurrentUserProfile()

  watch([isAnonymous, router.currentRoute], async ([newIsAnonymous, newRoute]) => {
    if (!newIsAnonymous) return
    if (!!newRoute.meta.isAnonymousAllowed) return
    await router.push({ name: 'defaultRedirectAthleteMoments', query: { doLogout: 'false' } })
  }, { immediate: true, deep: true })

  // NOTE: we tried to use the router.beforeEach hook, but it didn't work as expected
  // because the hook is called before the profile is available.
  // This hook would only work by internal route changes, not by browser navigation.
}

export default useAnonymousRouteGuard
